/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `hrm_profile` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class HrmProfileMesg : Mesg {
    public constructor() : super("HrmProfile", Profile.MesgNum.HRM_PROFILE)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** enabled. */
    public var enabled: Boolean?
        get() = (getFieldValue(ENABLED_FIELD_NUM) as? UByte)?.let { it.toInt() != 0 }
        set(value) = setFieldValue(ENABLED_FIELD_NUM, value?.let { if (it) 1 else 0 })

    /** hrm_ant_id. */
    public var hrmAntId: UShort?
        get() = getFieldValue(HRM_ANT_ID_FIELD_NUM) as? UShort
        set(value) = setFieldValue(HRM_ANT_ID_FIELD_NUM, value)

    /** log_hrv. */
    public var logHrv: Boolean?
        get() = (getFieldValue(LOG_HRV_FIELD_NUM) as? UByte)?.let { it.toInt() != 0 }
        set(value) = setFieldValue(LOG_HRV_FIELD_NUM, value?.let { if (it) 1 else 0 })

    /** hrm_ant_id_trans_type. */
    public var hrmAntIdTransType: UByte?
        get() = getFieldValue(HRM_ANT_ID_TRANS_TYPE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(HRM_ANT_ID_TRANS_TYPE_FIELD_NUM, value)

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val ENABLED_FIELD_NUM: UByte = 0u
        public const val HRM_ANT_ID_FIELD_NUM: UByte = 1u
        public const val LOG_HRV_FIELD_NUM: UByte = 2u
        public const val HRM_ANT_ID_TRANS_TYPE_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("Enabled", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("HrmAntId", 1u, BaseType.UINT16Z, 1.0, 0.0, "", false)
            fields[2] = Field("LogHrv", 2u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[3] = Field("HrmAntIdTransType", 3u, BaseType.UINT8Z, 1.0, 0.0, "", false)
            return fields
        }
    }
}
